import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem, darken } from 'polished';
import {
  getProductDefaultInfo,
  getCartProductInfo,
  getCartProductAvailabilityInfo,
  getNumberFromString,
} from '../../../../utilities/selectors';
import {
  getSanitasProductDefaultInfo,
  getSanitasCartProductInfo,
  getZemplinTrueCount,
} from '../../selectors';
import { OrderNrInput } from '../../Product/OrderNrInput';
import { StockInfo } from '../../Product/StockInfo';
import { ProductPriceCartTable } from '../../Product/ProductPriceCartTable';
import { TableTd, TableRow } from '../../General/Table';
import {
  FlexCol,
  FlexRowCenterHorizontal,
  FlexRowCenter,
  FlexRowCenterVertical,
  FlexRow,
} from '../../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../../Defaults/Text';
import { IconType, SvgIcon } from '../../General/SvgIcon';
import { CountSetter } from '../../ProductDetail/CountSetter';
import { FormInput } from '../../Form/FormInput';
import { DotDelimeter } from '../../General/DotDelimeter';
import { CustomNrStock } from './CustomNrStock';
import {
  getSymbolFromCurrency,
  arrayToObject,
  prop,
  round,
} from '../../../../utilities';
import { InfoText, InfoType } from '../../General/InfoText';
// import {CheckBox, Icon, IconImg} from "../../../..";
import * as box from '../../../../../assets/imitrade/check-square-solid.svg';
import { CheckBox } from '../../General/Checkbox';
import { __ } from 'react-i18n';
import {
  STOCK_EXTERNAL,
  STOCK_INTERNAL,
  NO_STOCK,
  ON_STOCK,
} from '../../constants';

export interface Props {
  product: any;
  addToCart: any;
  removeFromCart: any;
  theme: any;
  hasBottomBorder?: boolean;
  isPriceWithVat: boolean;
  handlePaintChange: (goodId: number, wantPaint: boolean) => void;
}

function ImitradeItemsTabRow({
  product,
  addToCart,
  theme,
  hasBottomBorder = true,
  removeFromCart,
  isPriceWithVat,
  handlePaintChange,
}: Props) {
  const {
    currency,
    picture,
    url,
    name,
    ordernr,
    productId,
    goodId,
    sumPrice: price,
    productNote,
    plu,
    attribs,
    saleByPackages,
  } = getCartProductInfo(product);
  const {
    unit,
    priceWithoutVat,
    price: pricePerUnit,
    priceForPiece,
  } = getSanitasProductDefaultInfo(product, 'good');

  const pckg = prop(product, 'good.package', null);
  const inPackage = getNumberFromString(pckg);
  const step = saleByPackages ? (inPackage > 0 ? inPackage : 1) : 1;

  const { count: initialCount, productPackages } = getSanitasCartProductInfo(
    product,
  );
  const [count, setCount] = React.useState(initialCount.toString());

  const [press, setPress] = React.useState(productNote ? true : false);
  const itemCount = unit === 'Mks' ? initialCount * 1000 : initialCount;
  const onStock = 1;

  const correctPrice = isPriceWithVat ? price : price;
  const pricePerUnitString =
    correctPrice / count > 0
      ? `${round(pricePerUnit, 10).toFixed(2)} ${getSymbolFromCurrency(
          currency,
        )}`
      : 'Upresníme';
  const priceString =
    correctPrice > 0
      ? `${round(correctPrice, 2).toFixed(2)} ${getSymbolFromCurrency(
          currency,
        )}`
      : 'Upresníme';

  const onStockCorrect = onStock;
  const storesMap: any = null;

  const stockText = onStockCorrect > 0 ? ON_STOCK : NO_STOCK;
  const color = onStockCorrect > 0 ? '#2CC5B7' : '#FF0000';
  const attribsString = attribs
    ? attribs.map(a => a.attrib_value).join(', ')
    : '';

  const handleCountChange = (
    newCount: string,
    shouldAddToCart: boolean = true,
  ) => {
    const withoutCommas = newCount.replace(',', '.');
    let newCountNumber = parseFloat(withoutCommas);

    if (isNaN(newCountNumber)) {
      setCount(newCount);
      return;
    }

    if (shouldAddToCart) {
      if (parseFloat(newCount) < step) {
        newCount = step.toFixed(3);
      }
      newCountNumber = parseFloat(newCount);
      const countDiff = -(initialCount - newCountNumber);
      const correctCount = getZemplinTrueCount(unit === 'Mks', countDiff);
      addToCart(product, correctCount);
    }

    if (!newCount) {
      newCount = '1';
    }
    setCount(newCount);
  };

  const handlePressChange = () => {
    handlePaintChange(goodId, !press);
    setPress(!press);
  };

  const handleRemoveClick = () => {
    removeFromCart(productId, goodId);
  };

  return (
    <>
      <ImageNameTableTd hasBottomBorder={hasBottomBorder}>
        <ImageWrapper to={url}>
          <Image alt={`Obrázok ku produktu ${name}`} src={picture} />
        </ImageWrapper>
        <NameInputWrapper>
          <NameLink to={url}>
            <Name>{name}</Name>
          </NameLink>
          <OrderNrStockWrapper>
            <OrderNr>{ordernr ? ordernr : plu}</OrderNr>
            <DotDelimeter />
            <Stock color={color}>{stockText}</Stock>
          </OrderNrStockWrapper>
          {attribsString ? <AttribsText>{attribsString}</AttribsText> : null}
        </NameInputWrapper>
      </ImageNameTableTd>

      <StyledTableTd hasBottomBorder={hasBottomBorder} align="right">
        <Price align="right">{pricePerUnitString}</Price>
      </StyledTableTd>

      <StyledTableTd hasBottomBorder={hasBottomBorder}>
        <CountWrapper>
          <CountSetter
            onChange={handleCountChange}
            unit={unit}
            count={count}
            step={step}
            marginToUnits={0}
          />
        </CountWrapper>
      </StyledTableTd>

      <StyledTableTd hasBottomBorder={hasBottomBorder}>
        <Package align="left">{priceString}</Package>
      </StyledTableTd>

      <StyledTableTd hasBottomBorder={hasBottomBorder} align="right">
        <SvgIcon
          onClick={handleRemoveClick}
          width={12}
          height={12}
          icon={IconType.x}
          marginLeft={0}
          marginRight={10}
          viewBox="0 0 12 12"
          alt="Odstrániť produkt"
          title="Odstrániť produkt"
          fill={'black'}
          cursor={'pointer'}
        />
      </StyledTableTd>
    </>
  );
}

const Input = styled.input`
  display: block;
  width: 100%;
  background: ${({ theme }) => theme.color.white};
  border: 0;
  border-top: ${({ theme }) => theme.borders.secondary};
  border-bottom: ${({ theme }) => theme.borders.secondary};
  border-radius: ${rem(2)};
  padding: 0;
  text-align: center;
  box-shadow: none;
  height: ${rem(48)};
  width: ${rem(38)};
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: 300;
  font-size: ${rem(14)};
  font-family: ${({ theme }) => theme.font.secondary};
  outline: none;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  -moz-appearance: textfield;
`;

const StyledTableTd = styled(TableTd)<{ hasBottomBorder: boolean }>`
  padding: ${rem(16)} 0;
  margin-left: ${rem(8)};
  border-bottom: ${({ hasBottomBorder, theme }) =>
    hasBottomBorder ? theme.borders.primary : 'none'};
`;

const CountWrapper = styled(FlexRowCenterHorizontal)`
  margin-left: ${rem(32)};
  margin-right: ${rem(32)};
`;

const ImageNameTableTd = styled(StyledTableTd)`
  display: flex;
  align-items: center;
`;

const ImageWrapper = styled(Link)`
  margin-right: ${rem(16)};
`;

const Image = styled.img`
  width: ${rem(48)};
  height: ${rem(48)};
  max-width: initial;
`;

const NameInputWrapper = styled(FlexCol)``;

const NameLink = styled(Link)`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.textPrimary};

  &:hover {
    text-decoration: underline;
  }
`;

const Name = styled(TextP)`
  font-size: ${rem(14)};
  line-height: ${rem(18)};
  margin-bottom: ${rem(4)};

  color: ${({ theme }) => theme.colors.black};
  text-align: left;
  font-family: ${({ theme }) => theme.font.primary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: ${rem(400)};
  transition: color 0.2s;

  &:hover {
    color: ${({ theme }) => darken(0.15, theme.colors.primary)};
  }

  ${({ theme }) => theme.mediab.l1300`
      max-width: ${rem(300)};
  `}

  ${({ theme }) => theme.mediab.l1150`
      max-width: ${rem(200)};
  `}
`;

const OrderNr = styled(Name)`
  color: #aaaaaa;
  font-size: ${rem(13)};
  margin: 0;

  &:hover {
    color: inherit;
  }
`;

const AttribsText = styled(OrderNr)`
  text-align: left !important;
  margin-top: ${rem(4)};
`;

const OrderNrStockWrapper = styled(FlexRowCenterVertical)`
  height: ${rem(18)};
`;

const Stock = styled(OrderNr)<{ color: string }>`
  color: ${({ color }) => color};
  font-size: ${rem(13)};
  margin: 0;

  &:hover {
    color: ${({ color }) => color};
  }
`;

const Price = styled(TextP)<{ align: string }>`
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  margin-left: ${rem(8)};
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.colors.black};
  text-align: ${props => (props.align ? props.align : 'center')} !important;
`;

const Package = styled(Price)`
  margin-left: 0;
`;

const StyledTableRow = styled(TableRow)`
  padding: ${rem(24)} 0;
  border-top: ${({ theme }) => theme.borders.primary};

  &:last-child {
    border-bottom: ${({ theme }) => theme.borders.primary};
  }
`;

const WithTheme: any = withTheme(ImitradeItemsTabRow);
export { WithTheme as ImitradeItemsTabRow, StyledTableRow };
